@if (blockedMessage) {
  <div class="page-blocked">
    <p>{{ blockedMessage }}</p>
  </div>
} @else {
@if (company) {
  <link rel="stylesheet" [href]="customStyle"/>
}

@if (!done) {
  <div class="restaurant-loader">
    <div class="loader">
      <fa-icon [icon]="faUtensils" [animation]="'spin'" size="lg"></fa-icon>
    </div>
  </div>
}
@if (done && dmenus.length > 0 && selectedDmenu == null) {
  <div class="main-container">
    <div class="main-body">
      <div class="pcategories-list">
        <div class="logo-container">
          <label>CARDÁPIOS</label>
          @if (logoPath) {
            <img [src]="logoPath"/>
          }
        </div>
        @if (availableLangs.length > 1) {
          <div class="flags-container">
            @for (language of availableLangs; track language) {
              <span class="flag" [class.flag-selected]="language.selected">
                <img (click)="selectLanguage(language)" alt="flag-{{language.abrev}}" [src]="language.flagUrl"/>
              </span>
            }
          </div>
        }
      </div>
      <div class="pcategory-first" style="height: 100px"></div>
      @for (dmenu of dmenus; track dmenu) {
        <div class="pcategory-container dmenu-container">
          @if (!dmenu.hidden && dmenu.isOnSchedule) {
            <div class="pcategory-body">
              <table class="dmenu-table">
                <tr (click)="goToDmenu(dmenu.id)">
                  <td class="dmenu-picture">
                    @if (dmenu.final_mini_picture_path) {
                      <img [src]="dmenu.final_mini_picture_path"/>
                    }
                  </td>
                  <td class="dmenu-text">
                    <span class="dmenu-name">{{ dmenu.translatedName }}</span>
                    <br/>
                    <span><small><i>{{ dmenu.translatedDescription }}</i></small></span>
                  </td>
                </tr>
              </table>
            </div>
          }
        </div>
      }
    </div>
    <div class="main-foot">
    </div>
  </div>
}
@if (done && (dmenus.length == 0 || (dmenus.length > 0 && selectedDmenu != null))) {
  <div class="main-container">
    <!-- Pcategories navbar -->
    <div class="pcategories-list sticky">
      @for (pcategory of pcategories; track pcategory; let i = $index) {
        <span class="badge badge-secondary pcategory-badge" [class.active-badge]="pcategory.is_active" (click)="scrollToPcategory(pcategory, i)">{{pcategory.translatedName}}</span>
      }
    </div>
    <!-- Space for logo -->
    @if (logoPath) {
      <div class="logo-container">
        <label>MENU</label>
        <img [src]="logoPath"/>
      </div>
    }
    @if (availableLangs.length > 1) {
      <div class="flags-container">
        @for (language of availableLangs; track language) {
          <span class="flag" [class.flag-selected]="language.selected">
            <img (click)="selectLanguage(language)" alt="flag-{{language.abrev}}" [src]="language.flagUrl"/>
          </span>
        }
      </div>
    }
    <div class="main-body">
      <!-- Pcategories + products listing -->
      @for (pcat of pcategories; track pcat; let i = $index) {
        <div class="pcategory-container" [class.hidden]="pcat.hidden">
          <div class="pcategory-head" [class.pcategory-first]="i == 0">
            {{ pcat.translatedName }}
          </div>
          <div class="pcategory-body">
            @for (product of pcat.products; track product) {
              <div class="product-container" [class.hidden]="product.hidden">
                <div class="product-head">
                  <!-- Product image -->
                  <img loading="lazy" [src]="product.final_mini_picture_path" class="product-image" (click)="showImage($event, product)"/>
                  <!-- Zoomed image modal -->
                  @if (selectedProduct && selectedProduct.id == product.id) {
                    <app-product-details [selectedProduct]="selectedProduct" (onClose)="closeProduct()"></app-product-details>
                  }
                  <!-- Product name and description -->
                  <span class="product-name">
                    {{ product.translatedName }}
                    <div class="product-description">
                      {{ product.translatedDescription }}
                    </div>
                  </span>
                  <!-- Product price -->
                  @if (showPrice) {
                    <span class="product-price">
                      {{ product.price | currency:'BRL':'' }}
                    </span>
                  }
                </div>
              </div>
            }
          </div>
          <div class="pcategory-foot"></div>
        </div>
      }
    </div>
    <div class="main-foot">
      @for (disclaimer of disclaimers; track disclaimer) {
        <div class="foot-warning"><small>{{disclaimer}}</small></div>
      }
    </div>
  </div>
}
@if (pcategories && pcategoriesOffset) {
  <app-scroll-top (onScroll)="pageScroll($event)" (onScrollFinished)="stoppedScrolling()"></app-scroll-top>
}
}
